class KennisbankGrid {
	constructor(config) {
		this.config = Object.assign({
			scope: '.kennisbank-grid',
			button: '[data-kennisbank-folder]',
			menu: '.nav-tabs',
			content: '[data-kennisbank-content]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initialContent = this.$scope.find(this.config.content).html();
		this.addEventListeners();

		let folderId = this.getUrlFolderId();
		if (folderId) {
			this.loadFolder(folderId, false);
		}
	}

	addEventListeners() {
		this.$scope.on('click', this.config.button, this.onButtonClick.bind(this));
		$(window).on('popstate', this.onPopState.bind(this));
	}

	onButtonClick(e) {
		e.preventDefault();
		this.loadFolder($(e.currentTarget).data('kennisbankFolder'), true);
	}

	onPopState() {
		let folderId = this.getUrlFolderId();

		if (folderId) {
			this.loadFolder(folderId, false);
			return;
		}

		this.$scope.find(this.config.content).html(this.initialContent);
		this.setActiveCategory(null);
	}

	loadFolder(folderId, pushState) {
		let $content = this.$scope.find(this.config.content);

		this.$scope.addClass('loading');

		$.get(this.$scope.data('kennisbankUrl'), {
			folder: folderId
		}).done(html => {
			$content.html(html);
			this.setActiveCategory($content.find('[data-kennisbank-category]').data('kennisbankCategory'));

			if (pushState) {
				history.pushState({}, '', '?folder=' + folderId);
			}
		}).always(() => {
			this.$scope.removeClass('loading');
		});
	}

	setActiveCategory(categoryId) {
		this.$scope.find(this.config.menu).find(this.config.button)
			.removeClass('active')
			.filter('[data-kennisbank-folder="' + categoryId + '"]')
			.addClass('active');
	}

	getUrlFolderId() {
		return new URLSearchParams(window.location.search).get('folder');
	}
}

export default new KennisbankGrid;
